import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/query-client";
import { ErrorBoundary } from "./ui/atoms/ErrorBoundary";
import { RootProvider } from "./features/layout/components/RootProvider";
import { initAnalytics } from "./lib/analytics";
import { initSentry } from "./lib/sentry";
import { migrateStorage, cleanupLegacyToken } from "./lib/migrate-storage";
import { initCapacitor } from "./lib/capacitor-init";
import "./index.css";

migrateStorage();
cleanupLegacyToken();
initSentry();
initAnalytics();
initCapacitor();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RootProvider />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
